import React from "react";

// helpers
import { formateDateandTime } from "../../../helpers/formats.js";

export default function HistoricoAnalise({ historico }) {
    return (
        <div className="contentGroup">
            <h5 className="subtitleCardInfo">Histórico de Ações Executadas</h5>
            {historico && historico.map((m, key) => (
                <>
                    {m.situacaoAnalise === "Aguardando Publicação" &&
                        <div key={key}>
                            <h5 className="subtitleCard">{m.situacaoAnalise}</h5>
                            <div className="row">
                                <div className="col-4 col-sm-6"><strong>Ação Executada: </strong>{m.acao}</div>
                                <div className="col-4 col-sm-6"><strong>Data/Hora: </strong>{formateDateandTime(m.dataHora)}</div>
                                <div className="col-4 col-sm-6"><strong>Usuário: </strong>{m.usuario_Nome}</div>
                                <div className="col-4 col-sm-6"><strong>Número SEI: </strong>{m.numeroProcesso}</div>
                                <div className="col-12 col-sm-12"><strong>Observações: </strong>{m.observacao}</div>
                                {m.prazoResponsividadeExcedido && <div className="col-12 text-danger"><strong>* Prazo de Responsividade Excedido</strong></div>}
                                {m.anexos.length > 0 && <div className="col-12"><strong>Anexos: </strong></div>}
                                {m.anexos.map((n, key2) => {
                                    return <div className="col-4">
                                        <a key={key2} target="_blank" href={n.anexo}><i class="fas fa-file-export"></i> {n.tipoAnexo}</a>
                                    </div>
                                })}
                            </div>
                        </div>
                    }
                    {m.situacaoAnalise !== "Aguardando Publicação" &&
                        <div key={key}>
                            <h5 className="subtitleCard">{m.situacaoAnalise}</h5>
                            <div className="row">
                                <div className="col-4 col-sm-6"><strong>Ação Executada: </strong>{m.acao}</div>
                                <div className="col-4 col-sm-6"><strong>Data/Hora: </strong>{formateDateandTime(m.dataHora)}</div>
                                <div className="col-4 col-sm-6"><strong>Usuário: </strong>{m.usuario_Nome}</div>
                                <div className="col-12 col-sm-12"><strong>Observações: </strong>{m.observacao}</div>
                                {m.prazoResponsividadeExcedido && <div className="col-12 text-danger"><strong>* Prazo de Responsividade Excedido</strong></div>}
                                {m.anexos.length > 0 && <div className="col-12"><strong>Anexos: </strong></div>}
                                {m.anexos.map((n, key2) => {
                                    return <div className="col-4">
                                        <a key={key2} target="_blank" href={n.anexo}><i class="fas fa-file-export"></i> {n.tipoAnexo}</a>
                                    </div>
                                })}
                            </div>
                        </div>
                    }
                </>
            ))}
        </div>
    );
}
